<div *ngIf="showLoading" class="animation-container" [class.bg-white]="loading.isFirstLoad">
  <ng-lottie
    (animationCreated)="handleAnimation($event)"
    [height]="'600px'"
    [options]="lottieConfig"
    [width]="'300px'">
  </ng-lottie>
</div>

